import React, { FC } from 'react';
import { usePage } from '~Scenes/Handy/Context/PageProvider';
import { useTableContext } from '~Scenes/Handy/Context/TableContext';
import HistoryOrder from '~Scenes/History-v2/Components/HistoryOrder';
import OngoingCheque from '~Scenes/History-v2/Components/OngoingCheque';

export type HistoryItemType = {
  itemId: string;
  title: string;
  amount: number;
  isRefunded: boolean;
  discount: number;
  variations: {
    id: string;
    name: string;
  }[];
};

const OngoingChequePage: FC = () => {
  const page = usePage();

  if (!page.slug) {
    return null;
  }

  return (
    <>
      <OngoingCheque chequeId={page.slug} />
    </>
  );
};

export default OngoingChequePage;
